module.exports = __webpack_public_path__ + "static/Hexomatic-logo-96cdbdd42ee5c8467900ae656e9c4e7c.pdf";